import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LogtoUser } from "../model/LogtoUser";
import { ContextService } from "./context.service";

@Injectable({
  providedIn: "root",
})
export class LogtoUsersService {
  constructor(private http: HttpClient, private context: ContextService) {}

  getUsers(): Observable<LogtoUser[]> {
    const token = localStorage.getItem("access_token") || "";
    return this.http.get<LogtoUser[]>(
      this.context._configurationEnvironment.service_engine_base_url + "logto/users",
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }
}
